var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"loader-fade"}},[(_vm.visible)?_c('div',{staticClass:"loader-overlay"},[_c('div',{staticClass:"loader-content"},[_c('div',{staticClass:"loader-spinner"}),_c('p',{staticClass:"loader-text"},[_vm._v(_vm._s(_vm.message))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }